/**
 * Хранит время последнего открытия сущности (инцидент / назначение) в localStorage.
 * Используется для определения, нужно ли показывать точку уведомления:
 * точка ставится если есть непрочитанное уведомление, созданное ПОЗЖЕ последнего открытия.
 */

const PREFIX = "casper:last-opened"

export type LastOpenedEntityType = "incident" | "assignment"

export function getLastOpened(type: LastOpenedEntityType, id: number): number {
  try {
    const val = localStorage.getItem(`${PREFIX}:${type}:${id}`)
    return val ? parseInt(val, 10) : 0
  } catch {
    return 0
  }
}

export function setLastOpened(type: LastOpenedEntityType, id: number): void {
  try {
    localStorage.setItem(`${PREFIX}:${type}:${id}`, Date.now().toString())
  } catch { /* ignore */ }
}
